import { render, staticRenderFns } from "./infoTabs.vue?vue&type=template&id=e7e19594&scoped=true&"
import script from "./infoTabs.vue?vue&type=script&lang=js&"
export * from "./infoTabs.vue?vue&type=script&lang=js&"
import style0 from "./infoTabs.vue?vue&type=style&index=0&id=e7e19594&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7e19594",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7e19594')) {
      api.createRecord('e7e19594', component.options)
    } else {
      api.reload('e7e19594', component.options)
    }
    module.hot.accept("./infoTabs.vue?vue&type=template&id=e7e19594&scoped=true&", function () {
      api.rerender('e7e19594', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/places/infoTabs.vue"
export default component.exports